export default {
  'message.error-message.title': "Quelque chose s'est mal passé",
  'message.success-message.title': 'Succès!',
};
